import { Trans, useTranslation } from "react-i18next";
import CustomModal from "components/lib/customModal";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const CommentInfoModal = ({ open, onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <CustomModal.Wrapper
      size="large"
      onClose={() => onClose()}
      open={open}
      titleText={t("PSYCHOLOGIST_COMMENT_TITLE")}
    >
      <p>
        <Trans
          i18nKey="AVAILABILITY_INFO_TEXT"
          components={{
            strong: <strong />,
            em: <em />,
            ul: <ul />,
            li: <li />,
          }}
        />
      </p>
    </CustomModal.Wrapper>
  );
};
